export const GET_RESOURCE_GROUP_REQUEST = "GET_RESOURCE_GROUP_REQUEST";
export const GET_RESOURCE_GROUP_SUCCESS = "GET_RESOURCE_GROUP_SUCCESS";
export const GET_RESOURCE_GROUP_FAILURE = "GET_RESOURCE_GROUP_FAILURE";

export const CREATE_NEW_RESOURCE_GROUP_REQUEST =
  "CREATE_NEW_RESOURCE_GROUP_REQUEST";
export const CREATE_NEW_RESOURCE_GROUP_SUCCESS =
  "CREATE_NEW_RESOURCE_GROUP_SUCCESS";
export const CREATE_NEW_RESOURCE_GROUP_FAILURE =
  "CREATE_NEW_RESOURCE_GROUP_FAILURE";

export const UPDATE_RESOURCE_GROUP_REQUEST = "UPDATE_RESOURCE_GROUP_REQUEST";
export const UPDATE_RESOURCE_GROUP_SUCCESS = "UPDATE_RESOURCE_GROUP_SUCCESS";
export const UPDATE_RESOURCE_GROUP_FAILURE = "UPDATE_RESOURCE_GROUP_FAILURE";

export const GET_DOWNLOAD_RESOURCE_GROUP_REQUEST =
  "GET_DOWNLOAD_RESOURCE_GROUP_REQUEST";
export const GET_DOWNLOAD_RESOURCE_GROUP_SUCCESS =
  "GET_DOWNLOAD_RESOURCE_GROUP_SUCCESS";
export const GET_DOWNLOAD_RESOURCE_GROUP_FAILURE =
  "GET_DOWNLOAD_RESOURCE_GROUP_FAILURE";

export const DELETE_RESOURCE_GROUP_REQUEST = "DELETE_RESOURCE_GROUP_REQUEST";
export const DELETE_RESOURCE_GROUP_SUCCESS = "DELETE_RESOURCE_GROUP_SUCCESS";
export const DELETE_RESOURCE_GROUP_FAILURE = "DELETE_RESOURCE_GROUP_FAILURE";

export const UPLOAD_EXCEL_FOR_RESOURCE_GROUP_REQUEST =
  "UPLOAD_EXCEL_FOR_RESOURCE_GROUP_REQUEST";
export const UPLOAD_EXCEL_FOR_RESOURCE_GROUP_SUCCESS =
  "UPLOAD_EXCEL_FOR_RESOURCE_GROUP_SUCCESS";
export const UPLOAD_EXCEL_FOR_RESOURCE_GROUP_FAILURE =
  "UPLOAD_EXCEL_FOR_RESOURCE_GROUP_FAILURE";

export const GET_LOCATIONS_FOR_RESOURCE_GROUP_REQUEST =
  "GET_LOCATIONS_FOR_RESOURCE_GROUP_REQUEST";
export const GET_LOCATIONS_FOR_RESOURCE_GROUP_SUCCESS =
  "GET_LOCATIONS_FOR_RESOURCE_GROUP_SUCCESS";
export const GET_LOCATIONS_FOR_RESOURCE_GROUP_FAILURE =
  "GET_LOCATIONS_FOR_RESOURCE_GROUP_FAILURE";
